"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormatSeconds = void 0;
const Add0toPrefix = (value) => {
    if (value < 10) {
        return `${0}${parseInt(`${value}`)}`;
    }
    return `${parseInt(`${value}`)}`;
};
// 毫秒
const FormatSeconds = (timestamp) => {
    var theTime = parseInt(`${timestamp / 1000}`); // 秒
    var middle = 0; // 分
    var hour = 0; // 小时
    if (Number(theTime) > 60) {
        middle = parseInt(`${theTime / 60}`);
        theTime = parseInt(`${theTime % 60}`);
        if (middle >= 60) {
            hour = parseInt(`${middle / 60}`);
            middle = parseInt(`${middle % 60}`);
        }
    }
    return `${Add0toPrefix(hour)}:${Add0toPrefix(middle)}:${Add0toPrefix(theTime)}`;
};
exports.FormatSeconds = FormatSeconds;
